export default "__VITE_ASSET__76c68796__"